import React, { useEffect } from "react";
import { Modal, Form, Input, Col, Row, message, Upload, Button } from "antd";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";
import { UploadOutlined } from "@ant-design/icons";

function AddImages(props) {
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi(
    "/admin/image",
    null,
    API_METHODS.POST,
    true
  );
  const [editResponse, editRequest] = useApi(
    `/admin/image/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT,
    true
  );

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  useEffect(() => {
    if (response.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Images added successfully.",
      });
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Images updated successfully.",
      });
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      const fileList = selectedRecord.images
        ? selectedRecord.images.map((img) => ({
            uid: String(img.id),
            name: img.path.split("\\").pop().split("/").pop(),
            status: "done",
            url: img.path,
          }))
        : [];
      form.setFieldsValue({
        title: selectedRecord.title,
        images: { fileList },
      });
    }
  }, [selectedRecord]);

  const handleCancel = () => {
    close();
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        formData.append("title", values.title);
        let images = (values.images?.fileList || []).filter(
          (f) => f.originFileObj
        );
        for (let i = 0; i < images.length; i++) {
          formData.append("images", images[i].originFileObj, images[i].name);
        }
        if (selectedRecord) {
          editRequest(formData);
        } else {
          request(formData);
        }
      })
      .catch((e) => {});
  };

  return (
    <Modal
      title={selectedRecord ? "Update Images" : "Add Images"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      {contextHolder}
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="title"
              label="Image Title"
              rules={[{ required: true, message: "Image Title is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="images" label="Upload Images">
              <Upload customRequest={dummyRequest} multiple={true}>
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddImages;
